export default __webpack_public_path__ + "static/media/CNo.85-3.bdd8f73e.jpg";